import { GET_CREDIT_SUBMISSION_CHANGELOG } from './getCreditSubmissionChangelog';

export const creditSubmissionChangelogApi = {
  getCreditSubmissionChangelog: GET_CREDIT_SUBMISSION_CHANGELOG,
};

export * from './types';
